"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeRestObject = void 0;
var IkeRestObject = /** @class */ (function () {
    function IkeRestObject() {
        this.cacheKeys = {
            objectId: true
        };
    }
    IkeRestObject.prototype.canCache = function (key) {
        return this.cacheKeys[key];
    };
    IkeRestObject.prototype.updateCache = function (key, result, rest) {
        return;
    };
    IkeRestObject.prototype.cacheIfLatest = function (key, result, rest) {
        if (result == null) {
            return null;
        }
        var value = result[key];
        var newFetchable = rest.getOne(this, key, value);
        if (newFetchable.hasFetched) {
            if (newFetchable.value == null || newFetchable.value.updatedAt < result.updatedAt) {
                newFetchable.init(result);
            }
        }
        else if (!newFetchable.isFetching) {
            newFetchable.init(result);
        }
    };
    return IkeRestObject;
}());
exports.IkeRestObject = IkeRestObject;
//# sourceMappingURL=base.js.map